import { Component, type ErrorInfo, type ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public override state: ErrorBoundaryState = { hasError: false };

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  public override componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("PERFECT DRAW encountered an unexpected error", error, errorInfo);
  }

  public override render(): ReactNode {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="fatal-error">
        <div className="fatal-error__card">
          <span className="fatal-error__mark" aria-hidden="true">
            !
          </span>
          <p className="eyebrow">A tiny wobble</p>
          <h1>Something went wrong</h1>
          <p>
            Your drawings are still stored on this device. Let’s return to your project library.
          </p>
          <a className="button button--primary" href="/">
            Back to my projects
          </a>
        </div>
      </main>
    );
  }
}
